<template>
  <div class="absolute w-full h-full top-0 left-0 bg-black-transparent flex items-center z-50">
    <div
      class=" relative popup w-6/10 1.5xl:w-5/10 fhd:w-4/10 h-4/10 mx-auto bg-white flex flex-col justify-evenly items-center">
        <a @click="$emit('cancel')" class="cursor-pointer"><i v-if="showCloseButton" class="fas fa-times text-3xl closeButton"></i></a>
      <div class="text-xl 4k:text-4xl">
        {{ this.phrase }}
      </div>

      <div class="actions flex justify-between">
        <button class="hover__button normal-case 4k:text-xl px-4" @click="$emit('cancel')">
          <p class="leading-none">{{ cancelText }}</p>
        </button>

        <button class="hover__button normal-case 4k:text-xl px-4" @click="$emit('confirm')">
          <p class="leading-none">{{ confirmText }}</p>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import getTranslation from "../../mixins/getTranslation";

export default {
  name: "ConfirmationPopup",

  mixins: [getTranslation],

  props: {
    phrase: {required: true, default: ''},
    confirmText: {required: false, default: 'delete'},
    cancelText: {required: false, default: 'cancel'},
    showCloseButton: {required: false, default: false},
  },
}
</script>

<style scoped>
button {
  height: 42px;
  min-width: 150px;
  border: var(--primary) 2px solid;
  color: var(--primary);
  border-radius: 25px;
}

.actions {
  width: 350px;
}

.closeButton {
    position: absolute;
    right: 2%;
    top: 2%;
}
</style>
